import usePageSEO from '@/hooks/usePageSEO';
import { useLanguage } from '@/contexts/LanguageContext';
import PageLayout from '@/components/feature/PageLayout';
import PartnershipHero from './components/PartnershipHero';
import PartnershipModes from './components/PartnershipModes';
import PartnershipTypes from './components/PartnershipTypes';
import PartnershipSupport from './components/PartnershipSupport';
import PartnershipCTA from './components/PartnershipCTA';

const siteUrl = (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SITE_URL) || 'https://www.juuliang.com';

export default function Partnership() {
  const { lang } = useLanguage();

  usePageSEO({
    title: {
      zh: '合作模式與經銷夥伴｜聚量應用材料 — 技術導入、區域經銷、ESG 循環經濟合作',
      en: 'Partnership & Distribution | PolyQ Applied Materials — Technology Implementation, Regional Distribution, ESG Circular Economy Cooperation',
      ja: 'パートナーシップ・販売代理 | 聚量応用材料 — 技術導入・地域販売代理・ESGサーキュラーエコノミー協力',
    },
    description: {
      zh: '聚量歡迎塑膠回收廠、造粒廠、材料經銷商、品牌端與政府單位，透過技術導入、區域經銷與 ESG 專案合作，共同拓展循環經濟市場。',
      en: 'PolyQ welcomes plastic recyclers, compounders, material distributors, brand owners, and government agencies to jointly expand the circular economy market through technology implementation, regional distribution, and ESG project cooperation.',
      ja: '聚量はプラスチックリサイクル業者・造粒業者・材料販売代理店・ブランドオーナー・政府機関を歓迎し、技術導入・地域販売代理・ESGプロジェクト協力を通じてサーキュラーエコノミー市場を共に拡大します。',
    },
    keywords: {
      zh: '合作模式, 經銷夥伴, 技術導入, 區域經銷, ESG 合作, 塑膠回收合作, 循環經濟夥伴, 聚量應用材料, 材料通路',
      en: 'partnership, distribution, technology implementation, regional distribution, ESG cooperation, plastic recycling partnership, circular economy partner, PolyQ Applied Materials, material channel',
      ja: 'パートナーシップ, 販売代理, 技術導入, 地域販売代理, ESG協力, プラスチックリサイクル協力, サーキュラーエコノミーパートナー, 聚量応用材料, 材料流通',
    },
    path: '/partnership',
    jsonLd: {
      '@type': 'WebPage',
      name: (lang === 'en' ? 'Partnership & Distribution' : lang === 'ja' ? 'パートナーシップ・販売代理' : '合作模式與經銷夥伴'),
      url: siteUrl + '/partnership',
      description: (lang === 'en'
        ? 'PolyQ welcomes plastic recyclers, compounders, material distributors, and brand owners for technology implementation, regional distribution, and ESG project cooperation.'
        : lang === 'ja'
          ? '聚量はプラスチックリサイクル業者・造粒業者・材料販売代理店・ブランドオーナーとの技術導入・地域販売代理・ESGプロジェクト協力を歓迎します。'
          : '聚量歡迎塑膠回收廠、造粒廠、材料經銷商、品牌端與政府單位，透過技術導入、區域經銷與 ESG 專案合作。'),
    },
  });

  return (
    <PageLayout>
      <PartnershipHero />
      <PartnershipModes />
      <PartnershipTypes />
      <PartnershipSupport />
      <PartnershipCTA />
    </PageLayout>
  );
}